export default "__VITE_ASSET__PxChdtct__"